function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D93845",
  fillRule: "evenodd",
  d: "M9.997 14.538c.333 0 .607-.282.615-.617l.179-7.591c.008-.34-.261-.626-.601-.634-.345-.005-.622.259-.63.598l-.178 7.6c-.009.339.26.644.6.644h.015zm-2.9 0h.015c.34 0 .609-.326.6-.666L7.535 6.27c-.008-.34-.287-.617-.63-.61-.34.008-.609.285-.6.625l.178 7.618c.008.335.282.635.615.635zM6.802 3.11h3.517v-.88H6.802v.88zm9.319.703c0 .389-.315.703-.703.703H1.703c-.388 0-.703-.314-.703-.703 0-.388.315-.703.703-.703h3.868V1.527c0-.34.227-.527.567-.527h4.845c.34 0 .566.188.566.527V3.11h3.869c.388 0 .703.315.703.703zm-1.864 2.354l-.537 10.167c-.02.373-.328.666-.702.666H4.103c-.374 0-.682-.293-.702-.666L2.864 6.167c-.02-.388.278-.719.666-.74.39-.018.719.278.74.666l.5 9.5h7.58l.502-9.5c.02-.388.354-.683.74-.665.387.02.685.351.665.74z"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.7f45f11c.svg";
export { ForwardRef as ReactComponent };